export default __webpack_public_path__ + "static/excelExport-87b6718fb445adbbf23cdf3f0869a94c.gif";